import React from 'react'
import PermissionError from './PermissionError'
import LoadingError from './LoadingError'
import NoContentError from './NoContentError'

export default function ErrorLoadingHandler({ error }) {
  switch (error?.message) {
    case 'Unauthorized':
      return <PermissionError />
    case 'No Content':
      return <NoContentError />
    default:
      return <LoadingError />
  }
}
